/*
Dentist Edit Profile Form Component
================================================================================
*/

/*
Imports
------------------------------------------------------------
*/
// libs
import React from 'react';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/lib/Row';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import {
  Field,
  FieldArray,
  FormSection,
  formValueSelector,
  reduxForm
} from 'redux-form';
import { bindActionCreators } from 'redux';
import LoadingSpinner from 'components/LoadingSpinner';

// app
import { US_STATES } from 'common/constants';
import Checkbox from 'components/Checkbox';
import DropzoneDisplay from 'components/DropzoneDisplay';
import Input from 'components/Input';
import InputGroup from 'components/InputGroup';
import InputTime from 'components/InputTime';
import LabeledInput from 'components/LabeledInput';


// local
import styles from './styles.module.css';
import LeadFormValidator from './validator';


/*
Redux
------------------------------------------------------------
*/
const valueSelector = formValueSelector('outOfNetwork');

const mapDispatchToProps = (dispatch) => ({
  submit: () => dispatch(submitForm('outOfNetwork')),
});

const mapStateToProps = (state) => {
  return valueSelector(state, 'changeEmail', 'changePassword','changePhone');
};
/*
Edit Profile Form
================================================================================
*/
@connect(mapStateToProps, mapDispatchToProps)
@reduxForm({
  form: 'outOfNetwork',
  enableReinitialize: true,
  validate: LeadFormValidator,
})
@CSSModules(styles, { allowMultiple: true })
class LeadForm extends React.Component {
  static propTypes = {
    // form related - passed in
    initialValues: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    submit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,

    // form values
    changeEmail: PropTypes.bool,
    changePassword: PropTypes.bool,
    changePhone:PropTypes.bool,

    // modal related - passed in
  };

  getCheckbox(props) {
    return new Checkbox(props);
  }

  getLabeledInput(props) {
    return new LabeledInput(props);
  }

  getInput(props) {
    return new Input(props);
  }

  /*
  Render
  ------------------------------------------------------------
  */
  render() {
    const {
      // form related

      handleSubmit,
      submit,
      submitting,
    } = this.props;

    return (
      <form
            onSubmit={handleSubmit}
            className="form-horizontal"
          >

              <Row>
                <Field
                  name="firstName"
                  type="text"
                  component={this.getLabeledInput}
                  label="First Name"
                  placeholder=""
                  className="col-sm-6"
                />

                <Field
                  name="lastName"
                  type="text"
                  component={this.getLabeledInput}
                  label="Last Name"
                  placeholder=""
                  className="col-sm-6"
                />
              </Row>
              <Row>
                <Field
                  name="email"
                  type="text"
                  component={this.getLabeledInput}
                  label="Email"
                  placeholder=""
                  className="col-sm-6"
                />

                <Field
                  name="company"
                  type="text"
                  component={this.getLabeledInput}
                  label="Practice Name"
                  placeholder=""
                  className="col-sm-6"
                />
                
              </Row>
              <Field
                  name="topicId"
                  type="hidden"
                  component={this.getInput}
                  className="col-sm-6"
                />
            <div className="modal-controls">
            <input
              type="button"
              className="modal-control"
              disabled={submitting}
              onClick={submit}
            value={submitting ? 'Submitting...':'Submit'}
            />
            {submitting && <LoadingSpinner showOnlyIcon />}
            </div>

          </form>
    );
  }
}


export default LeadForm;
